import {
  createContext,
  type ReactElement,
  type ReactNode,
  useContext,
  useEffect,
  useMemo,
  useSyncExternalStore,
} from "react";
import { queryClient } from "./query.js";
import { RealtimeClient, type RealtimeStatus } from "./realtime.js";

const RealtimeContext = createContext<RealtimeClient | null>(null);

/** Oturum açıkken WebSocket bağlantısını kurar; kiracı değişince (key) yeniden bağlanır. */
export function RealtimeProvider({ children }: { children: ReactNode }): ReactElement {
  const client = useMemo(() => new RealtimeClient(queryClient), []);
  useEffect(() => {
    client.connect();
    return () => client.disconnect();
  }, [client]);
  return <RealtimeContext.Provider value={client}>{children}</RealtimeContext.Provider>;
}

export function useRealtime(): RealtimeClient {
  const client = useContext(RealtimeContext);
  if (!client) throw new Error("useRealtime yalnızca <RealtimeProvider> içinde kullanılabilir");
  return client;
}

export function useRealtimeStatus(): RealtimeStatus {
  const client = useRealtime();
  return useSyncExternalStore(
    (listener) => client.onStatus(listener),
    () => client.status,
  );
}

/** Bir odaya (ör. `station:{id}`) bileşen yaşadığı sürece abone olur. */
export function useRoom(room: string | null): void {
  const client = useRealtime();
  useEffect(() => (room ? client.subscribe(room) : undefined), [client, room]);
}
